import actions from "src/actions";

export async function render({
  template,
  version,
  props,
}: {
  template: string;
  version: number;
  props: Record<string, any>;
}) {
  try {
    const response = await actions.ADMIN.renderEmail({
      template,
      version,
      props,
    });

    return response;
  } catch (err) {
    console.error(err);

    return {
      response: "Error rendering email",
      controller: null,
    };
  }
}
